import React from 'react';
import AnimatedSection from './AnimatedSection';
import StaggeredList from './StaggeredList';
import { Heart } from 'lucide-react';

const NurseTestimonialsSection = () => {
  const testimonials = [
    {
      quote: "It can take 6 or 7 hours to get a line back in.",
      role: "ICU Nurse"
    },
    {
      quote: "In the ER or ICU there are so many cords getting wrapped around, it takes time to unwind them and it pushes back [patient] care.",
      role: "ICU Nurse"
    },
    {
      quote: "Yes - a [thrombocytopenia] patient tripped on a power cord, hit their head, and died from brain bleed.",
      role: "ICU Nurse"
    },
    {
      quote: "Literally the bane of [my] existence.",
      role: "ICU Nurse"
    },
    {
      quote: "Patients coming back from the OR, cath lab, and imaging, were some of the most difficult times for cord management.",
      role: "ICU Nurse"
    },
    {
      quote: "Yes, I would definitely walk patients more and would be more excited to walk them if it didn't take 20 minutes to organize things.",
      role: "ICU Nurse"
    }
  ];

  return (
    <section className="py-16" style={{ backgroundColor: '#DFEAF0' }}>
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold mb-4" style={{ color: '#214140' }}>
              Nurses Say It Best
            </h2>
            <p className="text-lg text-gray-600">
              Real feedback from ICU nurses who face cord management challenges every shift
            </p>
          </div>

          <StaggeredList delay={120} className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-3 mb-3">
                  <Heart className="h-6 w-6 flex-shrink-0" style={{ color: '#8BBAB8' }} />
                  <p className="text-gray-700 italic">
                    "{testimonial.quote}"
                  </p>
                </div>
                <p className="text-sm font-semibold text-gray-500 pl-9">— {testimonial.role}</p>
              </div>
            ))}
          </StaggeredList>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default NurseTestimonialsSection;
